import { DocumentIcon } from 'assets/svg/sidebarIcons';
// ==============================|| UTILITIES MENU ITEMS ||============================== //

const reports = {
  id: 'reports',
  title: '',
  type: 'group',
  children: [
    {
      id: 'reports-management',
      title: 'Reports',
      type: 'item',
      url: '/reports',
      icon: DocumentIcon,
      allowedRoles: ['admin', 'superAdmin', 'financeManager', 'complianceOfficer', 'marketingSpecialist'],
      breadcrumbs: false
    }
  ]
};

export default reports;
